// Decision core for the PWA back-button trap (App.vue).
//
// The trap arms the "press back again to exit" window ONLY when the feed is
// certainly at the top. Getting this wrong is the bug we fixed: a scrolled
// feed that momentarily reads scrollTop ~0 (windowed snap reel re-windowing,
// or pre-layout on cold launch) looked "at top", so the first back armed exit
// and the next back closed the PWA. Bias every uncertain read to "not at top"
// (scroll-to-top + stay) instead of risking an exit.
//
// Inputs:
//   y      — currentFeedScrollY(): finite px, or NaN when unknown (container
//            present but unsized).
//   domTop — reelAtTop(): DOM snap-slide fallback. true/false when known,
//            null when there is no reel container to inspect.
export function isFeedCertainlyAtTop(y: number, domTop: boolean | null): boolean {
  if (Number.isFinite(y)) return y <= 8;
  // y is NaN → trust the DOM fallback only when it positively says "top".
  return domTop === true;
}
